module.exports = __webpack_public_path__ + "img/step-4.ecc71cf7.png";